module.exports = __webpack_public_path__ + "img/organigrama.01e7a1b0.jpg";